import { myShortlistFeedbackApi } from '../../../api/shortlist-feedback/shortlistFeedback.api.connected';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import { createShortlistFeedbackMutationService } from './ShortlistFeedbackMutationService.impl';

export const myShortlistFeedbackMutationService =
  createShortlistFeedbackMutationService({
    api: myShortlistFeedbackApi,
    services: {
      errorService: myErrorService,
      messageService: myMessageService
    }
  });
